/**
 * @generated SignedSource<<97aa78973b1b8994cb846f4069022d2d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignalOpenedByEmployeeButton_signal$data = {
  readonly employeeReceiverReceiptsCount: number;
  readonly id: string;
  readonly store: {
    readonly employeeCount: number;
    readonly id: string;
  };
  readonly " $fragmentType": "SignalOpenedByEmployeeButton_signal";
};
export type SignalOpenedByEmployeeButton_signal$key = {
  readonly " $data"?: SignalOpenedByEmployeeButton_signal$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignalOpenedByEmployeeButton_signal">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignalOpenedByEmployeeButton_signal",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employeeReceiverReceiptsCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "store",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employeeCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Signal",
  "abstractKey": null
};
})();

(node as any).hash = "4ebbcde1d55d63a60d351d7de7a089c8";

export default node;
